<template>
  <div
    class="all-segments-list-leftcol border-r-beige-10 border-r border-solid"
    data-cy="setting-list"
  >
    <div class="px-6 py-4">
      <h1 class="text-heading-1 text-beige-90 font-semibold!">Settings</h1>
    </div>
    <div
      class="[&>a]:text-black-1! [&>a]:hover:bg-beige-1! [&>a.router-link-active]:bg-beige-1! [&>a]:border-b-beige-10 flex flex-col px-2 [&>a]:w-full [&>a]:border-b [&>a]:border-solid [&>a]:px-6 [&>a]:py-2 [&>a]:text-sm [&>a]:last-of-type:border-none [&>a.router-link-active]:font-semibold!"
    >
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/system` }">
        Application
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/user_id` }">
        User ID Matching
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/usage_tracking` }">
        Usage Tracking
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/segment_traits` }">
        User Traits
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/tags` }">Tags</router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/triggers` }">
        Triggers
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/data_sources` }">
        Data Sources
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/connectors` }">
        Integrations
      </router-link>
      <router-link
        data-cy="setting-list--zones"
        :to="{ path: `/apps/${appsStore.app.id}/settings/zones` }"
      >
        Zones
      </router-link>
      <router-link
        v-if="appsStore.app.flags.custom_devices"
        data-cy="setting-list--custom-devices"
        :to="{ path: `/apps/${appsStore.app.id}/settings/custom_devices` }"
      >
        Custom Devices
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/users` }">Users</router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/app_messages` }">
        App Messages
      </router-link>
      <router-link
        v-if="userStore.isAdmin"
        :to="{ path: `/apps/${appsStore.app.id}/settings/custom_web_snippet` }"
      >
        Custom JS Snippet
      </router-link>
      <router-link
        v-if="userStore.isCurrentSuperAdmin"
        :to="{ path: `/apps/${appsStore.app.id}/settings/css_styles` }"
      >
        CSS Styles
      </router-link>
      <router-link :to="{ path: `/apps/${appsStore.app.id}/settings/download_csv` }">
        Download Data
      </router-link>
      <router-link
        v-if="userStore.isCurrentSuperAdmin"
        data-cy="setting-list--admin"
        :to="{ path: `/apps/${appsStore.app.id}/settings/admin` }"
      >
        Admin
      </router-link>
      <router-link
        v-if="userStore.isSales || userStore.isCurrentSuperAdmin"
        :to="{ path: `/apps/${appsStore.app.id}/settings/sales_admin` }"
      >
        Sales Admin
      </router-link>
      <router-link
        v-if="userStore.isCurrentSuperAdmin && appsStore.app.aws_marketplace_enabled === true"
        :to="{ path: `/apps/${appsStore.app.id}/settings/aws_marketplace` }"
      >
        AWS Marketplace
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { useAppsStore } from "@/pinia/appsStore";
import { useUserStore } from "@/pinia/userStore";

const userStore = useUserStore();
const appsStore = useAppsStore();
</script>
